import { Component, Input, OnInit } from '@angular/core';
import { ComponentData, TableData, TabUtil } from '@ddt-web/data-service';

@Component({
	selector: 'esg-holdings-table',
	templateUrl: './esg-holdings-table.component.html',
	styleUrls: ['./esg-holdings-table.component.scss']
})
export class EsgHoldingsTableComponent implements OnInit {
	@Input() public data: ComponentData;

	public tableData: TableData;
	public asOfDate: string;
	public titleDcrKey: string = 'ESG_HOLDINGS_TABLE';
	public subTitleDcrKey: string = 'ESG_HOLDINGS_TABLE_DESCRIPTION';
	public isTableDataTabValid: boolean;

	public ngOnInit(): void {
		this.asOfDate = this.data.getTabById('esg.asOfDate')?.tableData?.[0]?.cells?.[0]?.[0]?.formattedValue;

		const esgTab = this.data.getTabById('esg.holdings');
		this.isTableDataTabValid = TabUtil.isTabValid(esgTab);

		if (this.isTableDataTabValid) {
			this.tableData = esgTab.tableData?.[0];
		}
	}
}
